import { createToastStore } from '#pplx/frontend/aether/toasts/internal/createToastStore.js';
import { createContext } from 'react';
export const ToastStoreContext = createContext(undefined);
ToastStoreContext.displayName = 'ToastStoreContext';
//# sourceMappingURL=ToastStoreContext.js.map